export const MEMBERSHIP_BUSINESS = "Business Membership";
export const MEMBERSHIP_EXECUTIVE = "Executive Membership";

/** When false, Business/Executive member tier pricing does not apply (delegation/tour). */
export function eventEligibleForMemberTierDiscount(
  memberEventDiscountEligible?: boolean | null,
): boolean {
  return memberEventDiscountEligible !== false;
}

/** Member event pricing requires completed membership payment, not just a saved plan selection. */
export function userQualifiesForMemberEventDiscount(
  user?: {
    membershipName?: string | null;
    hasPaid?: number | null;
  } | null,
): boolean {
  if (user?.hasPaid !== 1) return false;
  const name = user.membershipName?.trim();
  return name === MEMBERSHIP_BUSINESS || name === MEMBERSHIP_EXECUTIVE;
}

export function isPaidExecutiveMember(
  user?: {
    membershipName?: string | null;
    hasPaid?: number | null;
  } | null,
): boolean {
  return user?.hasPaid === 1 && user.membershipName === MEMBERSHIP_EXECUTIVE;
}
